import type { ReactNode } from "react";

/**
 * What a list says when it has nothing to show: a large faint icon, a line, a
 * word more, and whatever there is to do about it.
 */
export function EmptyState({ icon, title, text, action, className = "" }: { icon: ReactNode; title: string; text?: string; action?: ReactNode; className?: string }) {
  return (
    <div className={`flex flex-col items-center px-8 pt-[18vh] text-center ${className}`}>
      <div className="mb-4 text-line-strong [&>svg]:h-14 [&>svg]:w-14">{icon}</div>
      <h2 className="text-[18px] font-semibold text-ink">{title}</h2>
      {text && <p className="mt-1.5 max-w-xs text-[14px] text-ink-soft">{text}</p>}
      {action && <div className="mt-6">{action}</div>}
    </div>
  );
}
